<template>
    <div class="selected-products">
        <div class="selected-products__tile" v-for="(product, index) in products" :key="product.id">
            <div class="selected-products__title">
                {{ product.title }}
            </div>

            <div class="selected-products__icon" @click="removeProduct(index)">
                <img src="/images/icons/delete.svg" />
            </div>

            <input type="hidden" name="products[]" :value="product.id"/>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'products',
        event: 'input'
    },

    props : {
        products: Array,
    },

    methods: {
        removeProduct(productIndex) {
            if (this.products.length > 1) {
                this.products.splice(productIndex, 1);
            }
        },
    },
}
</script>
